import { GENERATE_ALL_PAGES } from '@monoimin/constants';

import type { StaticPaths } from '@monoimin/sb-types';

export const decorateParamsGeneration = (
  folder: string,
  callback: () => Promise<StaticPaths> | StaticPaths
) => {
  return async () => {
    try {
      if (GENERATE_ALL_PAGES) {
        return await callback();
      }

      // eslint-disable-next-line no-console
      console.log(
        `Skipping static params generation for ${folder} (GENERATE_ALL_PAGES is false)`
      );
      return [];
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error generating static params for ${folder}:`, error);

      throw error;
    }
  };
};

export default decorateParamsGeneration;
